import { Link } from "react-router-dom";

import { EM_DASH } from "@/lib/utils";

import type { QualityEventNcrRow } from "./qualityEventPageApi";

function dispositionLabel(value: string | null): string {
  if (value == null || value.trim() === "") return EM_DASH;
  return value
    .split("_")
    .filter((part) => part !== "")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function QualityEventNcrTable({ ncrs }: { ncrs: QualityEventNcrRow[] }): JSX.Element {
  if (ncrs.length === 0) {
    return <p className="text-sm text-slate-600">No NCRs linked to this event.</p>;
  }

  return (
    <div className="overflow-auto">
      <table className="min-w-full border-separate border-spacing-0 text-sm">
        <thead className="sticky top-0 z-10 text-left text-xs uppercase tracking-wide text-slate-500">
          <tr>
            <th className="sticky top-0 border-b border-slate-200 bg-slate-50 px-2 py-2 text-right">Number</th>
            <th className="sticky top-0 border-b border-slate-200 bg-slate-50 px-2 py-2">Status</th>
            <th className="sticky top-0 border-b border-slate-200 bg-slate-50 px-2 py-2">Disposition</th>
            <th className="sticky top-0 border-b border-slate-200 bg-slate-50 px-2 py-2">RCA</th>
          </tr>
        </thead>
        <tbody>
          {ncrs.map((ncr) => (
            <tr key={ncr.id} className="hover:bg-slate-50/80">
              <td className="border-b border-slate-100 px-2 py-2 text-right tabular-nums">
                <Link className="text-sky-700 hover:underline" to={`/quality/ncrs/${ncr.id}`}>
                  {ncr.id}
                </Link>
              </td>
              <td className="border-b border-slate-100 px-2 py-2">{ncr.open ? "Open" : "Closed"}</td>
              <td className="border-b border-slate-100 px-2 py-2">{dispositionLabel(ncr.repairScrap)}</td>
              <td className="border-b border-slate-100 px-2 py-2 tabular-nums">
                {ncr.rcaId == null ? (
                  EM_DASH
                ) : (
                  <Link className="text-sky-700 hover:underline" to={`/quality/rcas/${ncr.rcaId}`}>
                    {ncr.rcaId}
                  </Link>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
